import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function LearningProgress() {
  const [children, setChildren] = useState([])
  const [selectedChild, setSelectedChild] = useState(null)
  const [progressData, setProgressData] = useState(null)
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')

  useEffect(() => { loadChildren() }, [])

  const loadChildren = () => {
    setLoading(true)
    fetch(`${API}/learning-progress`).then(r => r.json())
      .then(d => { if (d.success) setChildren(d.data || []) })
      .finally(() => setLoading(false))
  }

  const loadChildProgress = (childId) => { fetch(`${API}/learning-progress/${childId}`).then(r => r.json()).then(d => { if (d.success) setProgressData(d.data) }) }

  const filteredChildren = children.filter(c => {
    if (filter === 'all') return true
    if (filter === 'in_progress') return c.in_progress_chapters > 0
    if (filter === 'completed') return c.completed_chapters > 0 && c.in_progress_chapters === 0
    return true
  })

  const getProgressRate = (child) => {
    if (!child.total_chapters || child.total_chapters === 0) return 0
    return Math.round((child.completed_chapters / child.total_chapters) * 100)
  }

  return (
    <div>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📚 孩子学习进度</h2>
      <p style={{ color: '#666', marginBottom: 20 }}>查看所有孩子的课程学习进度和完成情况</p>

      <div style={{ display: 'flex', gap: 12, marginBottom: 20 }}>
        {[
          { k: 'all', l: '全部', n: children.length },
          { k: 'in_progress', l: '学习中', n: children.filter(c => c.in_progress_chapters > 0).length },
          { k: 'completed', l: '已完成', n: children.filter(c => c.completed_chapters > 0 && c.in_progress_chapters === 0).length },
        ].map(f => (
          <button key={f.k} onClick={() => setFilter(f.k)} style={{ padding: '8px 16px', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, background: filter === f.k ? '#1890ff' : '#f5f5f5', color: filter === f.k ? '#fff' : '#666' }}>
            {f.l} ({f.n})
          </button>
        ))}
      </div>

      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr style={{ background: '#fafafa' }}>{['孩子', '学校', '学习中', '已完成', 'AI创作营', '总进度', '操作'].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
          <tbody>
            {loading ? <tr><td colSpan={7} style={{ ...td, textAlign: 'center', padding: 40 }}>加载中...</td></tr>
             : filteredChildren.length === 0 ? <tr><td colSpan={7} style={{ ...td, textAlign: 'center', padding: 40, color: '#999' }}>暂无数据</td></tr>
             : filteredChildren.map(child => (
                <tr key={child.child_id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={td}><div style={{ fontWeight: 500 }}>{child.child_name}</div></td>
                  <td style={td}>{child.school || '-'}</td>
                  <td style={td}>{child.in_progress_chapters > 0 ? <span style={{ color: '#1890ff', fontWeight: 500 }}>{child.in_progress_chapters} 课程</span> : '-'}</td>
                  <td style={td}>{child.completed_chapters > 0 ? <span style={{ color: '#52c41a', fontWeight: 500 }}>{child.completed_chapters} 课程</span> : '-'}</td>
                  <td style={td}>
                    {child.aicamp_enrollment_id ? (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                        <span>🤖</span>
                        <span style={{ fontSize: 12, color: '#722ed1', fontWeight: 500 }}>
                          {child.aicamp_total_lessons > 0 ? Math.round((child.aicamp_completed_lessons / child.aicamp_total_lessons) * 100) + '%' : '刚报名'}
                        </span>
                      </div>
                    ) : <span style={{ color: '#ccc' }}>-</span>}
                  </td>
                  <td style={td}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div style={{ width: 80, height: 6, background: '#f0f0f0', borderRadius: 3 }}><div style={{ width: `${getProgressRate(child)}%`, height: '100%', background: getProgressRate(child) === 100 ? '#52c41a' : '#1890ff', borderRadius: 3 }} /></div>
                      <span style={{ fontSize: 12, color: '#999' }}>{getProgressRate(child)}%</span>
                    </div>
                  </td>
                  <td style={td}><button onClick={() => { setSelectedChild(child); loadChildProgress(child.child_id) }} style={{ padding: '4px 12px', background: '#f5f5f5', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }}>查看详情</button></td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>

      {selectedChild && progressData && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 24, width: 600, maxHeight: '80vh', overflow: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
              <h3>{selectedChild.child_name} - 学习详情</h3>
              <button onClick={() => { setSelectedChild(null); setProgressData(null) }} style={{ padding: '4px 8px', background: 'none', border: 'none', cursor: 'pointer', fontSize: 18 }}>×</button>
            </div>

            {progressData.aicamp && (
              <div style={{ marginBottom: 20 }}>
                <h4 style={{ fontSize: 14, marginBottom: 12, color: '#722ed1' }}>🤖 AI创作营</h4>
                <div style={{ padding: 16, background: 'linear-gradient(135deg, #722ed1 0%, #eb8c34 100%)', borderRadius: 12, color: '#fff' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                    <div><div style={{ fontSize: 16, fontWeight: 600 }}>{progressData.aicamp.product_name}</div><div style={{ fontSize: 12, opacity: 0.8 }}>¥{progressData.aicamp.price}</div></div>
                    <div style={{ textAlign: 'right' }}><div style={{ fontSize: 28, fontWeight: 600 }}>{progressData.aicamp.progress_rate}%</div><div style={{ fontSize: 12, opacity: 0.8 }}>完成进度</div></div>
                  </div>
                  <div style={{ width: '100%', height: 8, background: 'rgba(255,255,255,0.3)', borderRadius: 4 }}><div style={{ width: `${progressData.aicamp.progress_rate}%`, height: '100%', background: '#fff', borderRadius: 4 }} /></div>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: 8, fontSize: 12, opacity: 0.8 }}><span>已学 {progressData.aicamp.completed_lessons} 课时</span><span>共 {progressData.aicamp.total_lessons} 课时</span></div>
                </div>
              </div>
            )}

            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 12, marginBottom: 20 }}>
              {[{ label: '总课程', value: progressData.stats?.total_courses || 0, color: '#1890ff', bg: '#f0f5ff' }, { label: '已完成', value: progressData.stats?.completed_courses || 0, color: '#52c41a', bg: '#f6ffed' }, { label: '进行中', value: progressData.stats?.in_progress_courses || 0, color: '#fa8c16', bg: '#fff7e6' }].map(s => (
                <div key={s.label} style={{ padding: 16, background: s.bg, borderRadius: 8, textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 600, color: s.color }}>{s.value}</div><div style={{ fontSize: 12, color: '#666' }}>{s.label}</div></div>
              ))}
            </div>

            <h4 style={{ fontSize: 14, marginBottom: 12 }}>课程进度</h4>
            {progressData.courses && progressData.courses.length > 0 ? progressData.courses.map((course, i) => (
              <div key={i} style={{ padding: 12, background: '#fafafa', borderRadius: 8, marginBottom: 8, display: 'flex', justifyContent: 'space-between' }}>
                <span style={{ fontWeight: 500 }}>{course.course_title || '课程' + course.course_id}</span>
                <span style={{ padding: '2px 8px', borderRadius: 4, fontSize: 12, background: course.status === 'completed' ? '#f6ffed' : '#e6f7ff', color: course.status === 'completed' ? '#52c41a' : '#1890ff' }}>{course.status === 'completed' ? '已完成' : '进行中'}</span>
              </div>
            )) : <div style={{ textAlign: 'center', padding: 20, color: '#999' }}>暂无课程记录</div>}
          </div>
        </div>
      )}
    </div>
  )
}

const th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const td = { padding: 12, fontSize: 13 }
